<div
  class="d-flex flex-column justify-content-between"
  style="min-height: 30vh"
  (window:keydown.arrowleft)="currentPageNumber() > 1 ? currentPageNumber.set(currentPageNumber() - 1) : null"
  (window:keydown.arrowright)="currentPageNumber() < (pageCount() ?? 0) ? currentPageNumber.set(currentPageNumber() + 1) : null"
>
  @if (isLoading()) {
    <app-loading-spinner [isLoading]="true" />
  } @else {
    @if (errorMessage(); as errorMessage) {
      <div class="d-flex flex-column justify-content-center" style="flex: 1">
        <div class="alert alert-warning" role="alert">
          <div class="alert-message text-center" data-cy="pdfErrorText">{{ errorMessage }}</div>
        </div>
      </div>
    }
    <ng-container *ngTemplateOutlet="paginator" />
  }
  <canvas #renderCanvas style="width: 100%; height: 100%"></canvas>
  @if (!isLoading()) {
    <ng-container *ngTemplateOutlet="paginator" />
  }
</div>

<ng-template #paginator>
  @if (!isLoading() && !errorMessage() && (pageCount() ?? 0) > 1) {
    <div class="d-flex justify-content-center gap-3">
      <chitin-icon
        icon="fa-solid fa-chevron-left"
        (click)="currentPageNumber() > 1 ? currentPageNumber.set(currentPageNumber() - 1) : null"
        class="clickable"
        [ngClass]="{ disabled: currentPageNumber() === 1 }"
      />
      <div>{{ currentPageNumber() }} / {{ pageCount() }}</div>
      <chitin-icon
        icon="fa-solid fa-chevron-right"
        (click)="currentPageNumber() < (pageCount() ?? 0) ? currentPageNumber.set(currentPageNumber() + 1) : null"
        class="clickable"
        [ngClass]="{ disabled: currentPageNumber() === pageCount() }"
      />
    </div>
  }
</ng-template>
